// extracted by mini-css-extract-plugin
export default {"container":"HotSpot_container__VPEQ1","decodedText":"HotSpot_decodedText__6+WTx"};